import React, { Component } from 'react'
import Projectdetail from './Projectdetail'
import Imagerow from './components/Imagerow'
import Updates from './components/Projupdates'

export class Calvary extends Component {

  render() {
    return (
      <React.Fragment>
        <Projectdetail
          image="assets/img/herobg-proj-detail-calvary.jpg"
          heading="Mount Calvary Baptist Church"
          content={[
            <>
              <p>
              Was asked by the Senior Pastor of Mount Calvary Baptist Church, to design and implement a website for the church. Visitors to the site can get an in-depth look at the history of the church, some its members, and the many events they have throughout the year, which are continuously updated by myself. Since its creation the website continues to be a valuable tool in helping the church spread its message and reach a wider audience.
              </p>
            </>
          ]}
          website="http://www.mcbcspringfield.org"
          github=""
          techs={[
            <>
              <li>Html</li>
              <li>CSS</li>
              <li>JavaScript</li>
            </>
          ]}
          updates={
            [  ]
          }
          images={[
            <>
                <Imagerow images="assets/img/screenshots/lrg/weqed.jpg" />
                <Imagerow images="assets/img/screenshots/lrg/ggujyg.jpg" />
                <Imagerow images="assets/img/screenshots/lrg/7897898.jpg" />
                <Imagerow images="assets/img/screenshots/lrg/465445.jpg" />
                <Imagerow images="assets/img/screenshots/lrg/casdcfas.jpg" />
                <Imagerow images="assets/img/screenshots/lrg/dasweq.jpg" />
            </>
          ]}
        />
      </React.Fragment>
    );
  }
}

export default Calvary
